export const registrationSchema = {
  email: {
    presence: { allowEmpty: false },
    email: true,
  },
  fullName: {
    presence: { allowEmpty: false },
  },
  phoneNumber: {
    presence: { allowEmpty: false },
  },
  category: {
    presence: { allowEmpty: false },
  },
  companyName: {
    presence: { allowEmpty: false },
  },
  incorporationNumber: {
    presence: { allowEmpty: false },
  },
};
